import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableBillingManagement = Loadable({
  loader: function loader() {
    return import('../BillingManagement.jsx');
  },
  loading: ComponentLoading
});
export default LoadableBillingManagement;